<template>
  <div class="input-group">
    <input
      type="number"
      :class="'form-control ' + input.class"
      :value="value"
      @change="(e) => handleChange(e)"
      @blur="(e) => handleBlur(e)"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :readonly="input.readonly"
      :name="input.name"
      :max="100"
      :min="0"
    />
    <div class="input-group-append">
      <span class="input-group-text">%</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "InputPercentage",
  components: {},
  props: {
    input: Object,
    value: [String, Number],
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
    handleBlur(e) {
      this.$emit("handleBlur", e);
    },
  },
};
</script>
